import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';

const ToastContext = createContext(null);

const SUCCESS_DURATION_MS = 2500;
const ERROR_DURATION_MS = 4000;
const INFO_DURATION_MS = 3000;

export function ToastProvider({ children }) {
  const [toast, setToast] = useState({ message: '', type: 'info', visible: false });
  const timeoutRef = useRef(null);

  const clearToast = useCallback(() => {
    setToast((prev) => (prev.visible ? { ...prev, visible: false } : prev));
  }, []);

  const showToast = useCallback((message, type = 'info') => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    const duration =
      type === 'success' ? SUCCESS_DURATION_MS : type === 'error' ? ERROR_DURATION_MS : INFO_DURATION_MS;
    setToast({ message, type, visible: true });
    timeoutRef.current = setTimeout(() => {
      setToast((prev) => (prev.visible ? { ...prev, visible: false } : prev));
      timeoutRef.current = null;
    }, duration);
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const value = { toast, showToast, clearToast };
  return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
